import React, { useEffect, useState } from "react";
import { searchAPI } from "../../services/api/search";
import Spinner from "../UI/Spinner";
import styles from "../../styles/SubscriptionList.module.css";
import ListUI from "./ListUI";
import { getCookie } from "../../utils/common";

const SearchSubscriptionList = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [list, setList] = useState<any[]>([]);

  useEffect(() => {
    getSubscriptionList();
  }, []);

  const getSubscriptionList = () => {
    setError("");
    if (isLoading) return;

    setIsLoading(true);

    const tenantSlug = getCookie("current_tenant");
    searchAPI(tenantSlug)
      .getAll?.()
      .then((response) => {
        const result = response.sort(
          (a: any, b: any) => a.order_no - b.order_no
        );
        setList(result);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setError("Something went wrong. Please try again later.");
        console.log(err);
      });
  };

  return (
    <div className={styles.SubscriptionList}>
      <h6>search subscriptions ({list.length > 0 ? list.length : 0})</h6>
      <div className="row">
        {isLoading && (
          <div className="d-flex justify-content-center my-5">
            <Spinner size="md" />
          </div>
        )}
        {!isLoading && list.length > 0 && (
          <ListUI
            list={list}
            styles={styles}
            getSubscriptionList={getSubscriptionList}
          />
        )}
        {!isLoading && !list.length && <div>{error}</div>}
      </div>
    </div>
  );
};

export default SearchSubscriptionList;
